var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return !_vm.showRouterView
    ? _c(
        "v-container",
        {
          staticClass: "px-0",
          attrs: {
            fluid: ""
          }
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-card",
                    [
                      _c("gg-card-header", [_vm._v(" List Domains ")]),
                      _c(
                        "gg-card-text",
                        [
                          _c("v-data-table", {
                            attrs: {
                              items: _vm.items,
                              headers: _vm.headers,
                              loading: _vm.pendingDomains
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item.status",
                                  fn: function fn(_ref) {
                                    var item = _ref.item
                                    return [
                                      _vm.pendingDetails
                                        ? _c("v-progress-circular", {
                                            attrs: {
                                              indeterminate: "",
                                              color: "primary",
                                              width: "2",
                                              size: "16"
                                            }
                                          })
                                        : _vm._l(item.status, function(
                                            item,
                                            key
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: key
                                              },
                                              [
                                                item.type === "DKIM"
                                                  ? _c("div", [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(item.type)
                                                        )
                                                      ]),
                                                      _vm._v(
                                                        ": " +
                                                          _vm._s(
                                                            _vm.dkimStatus(
                                                              item.issue
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                item.type === "SPF"
                                                  ? _c("div", [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(item.type)
                                                        )
                                                      ]),
                                                      _vm._v(
                                                        ": " +
                                                          _vm._s(
                                                            _vm.spfStatus(
                                                              item.issue
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                item.type === "Reverse DNS"
                                                  ? _c("div", [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(item.type)
                                                        )
                                                      ]),
                                                      _vm._v(
                                                        ": " +
                                                          _vm._s(
                                                            _vm.ptrsStatus(
                                                              item.issue
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ]
                                            )
                                          })
                                    ]
                                  }
                                },
                                {
                                  key: "item.actions",
                                  fn: function fn(_ref2) {
                                    var item = _ref2.item
                                    return [
                                      !_vm.pendingDomains && !_vm.pendingDetails
                                        ? [
                                            !item.local_authority
                                              ? [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        top: "",
                                                        "max-width": "250"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function fn(
                                                              _ref3
                                                            ) {
                                                              var on = _ref3.on,
                                                                attrs =
                                                                  _ref3.attrs
                                                              return [
                                                                _c(
                                                                  "v-icon",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        attrs: {
                                                                          color:
                                                                            "error",
                                                                          dark:
                                                                            ""
                                                                        }
                                                                      },
                                                                      "v-icon",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      " mdi-alert "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          ' This system does not control DNS for the "' +
                                                            _vm._s(
                                                              item.domain
                                                            ) +
                                                            "\" domain, and the system did not find any authoritative nameservers for this domain. Contact your domain registrar to verify this domain's registration. "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              : _vm._e()
                                          ]
                                        : _vm._e(),
                                      _c(
                                        "gg-btn",
                                        {
                                          staticClass: "ml-5",
                                          attrs: {
                                            primary: ""
                                          },
                                          on: {
                                            click: function click($event) {
                                              return _vm.manageDomain(
                                                item.domain
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(" Manage ")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2215706203
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _c("router-view")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }